module.exports = __webpack_public_path__ + "static/media/sessionAuth.b99657c3.png";